<p-password
  #input
  class="ui-input ui-password"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelled]="ariaLabelledBy"
  [class.ui-input-has-error]="hasError"
  [class.p-inputtext-lg]="size === 'large'"
  [class.p-inputtext-sm]="size === 'small'"
  [class.p-password-xs]="size === 'tiny'"
  [ngClass]="addClass"
  [name]="name"
  [disabled]="isDisabled"
  [placeholder]="placeholder"
  [maxlength]="maxlength"
  [minlength]="minlength"
  [(ngModel)]="value"
  [toggleMask]="toggleMask"
  [feedback]="feedback"
  (ngModelChange)="onValueChanged($event)"
  (keypress)="inputKeyPress.emit($event)"
>
  <ng-template pTemplate="header">
    <h6>Pick a password</h6>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-divider></p-divider>
    <p class="mt-2">Suggestions</p>
    <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
      <li>At least one lowercase</li>
      <li>At least one uppercase</li>
      <li>At least one numeric</li>
      <li>Minimum 8 characters</li>
    </ul>
  </ng-template>
</p-password>
